import { BaseSortPlainObject } from './baseSort.plainObject';
import { ExpressionColumnPlainObject } from './expressionColumn.plainObject';

export class ParsePlainObject extends BaseSortPlainObject {
    public columns: ExpressionColumnPlainObject[] = [];
}
